import { useState } from "react";
import { useInView } from 'react-intersection-observer';
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import SharedTable from "../../benefitPlan/SharedTable";
import { SUB_ACCOUNT_DRAFT } from "../../../utils/constants";

const step = 4;
const TopAccountStepFour = ({ activeStep, onCreateEditButtonClicked }) => {
    const { control, setValue, getValues } = useFormContext();
    const { remove } = useFieldArray({
        control,
        name: "subAccounts",
    });
    const subAccounts = useWatch({ control, name: "subAccounts" }) ?? [];

    const [showMoreColumns, setShowMoreColumns] = useState(false);
    const { ref } = useInView();

    if (activeStep !== step) return null;

    const subAccountRows = subAccounts
        .map(account => ({
            ...account,
            parentAccount: account.parentAccount.label,
            accountType: account.accountType.label,
            subscriptionsAllowed: account.subscriptionsAllowed ? 'YES' : 'NO',
            billParent: account.billParent ? 'YES' : 'NO',
            billingCycle: account.billParent ? 'N/A' : account.billingCycle.label,
            primaryAddressState: account.primaryAddressState.value,
            billingAddress1: account.billParent ? 'N/A' : account.billingAddress1,
            billingAddress2: account.billParent ? 'N/A' : account.billingAddress2,
            billingAddress3: account.billParent ? 'N/A' : account.billingAddress3,
            billingAddressCity: account.billParent ? 'N/A' : account.billingAddressCity,
            billingAddressState: account.billParent ? 'N/A' : account.billingAddressState.value,
            billingAddressZip: account.billParent ? 'N/A' : account.billingAddressZip,
        }));

    let columns = ['parentAccount', 'accountName', 'accountHccId', 'accountType', 'subscriptionsAllowed', 'billParent', 'billingCycle'];

    if (showMoreColumns) {
        columns = [
            ...columns,
            'ignorePrimaryAddressCheck', 'primaryAddress1', 'primaryAddress2', 'primaryAddress3', 'primaryAddressCity',
            'primaryAddressState', 'primaryAddressZip', 'ignoreBillingAddressCheck', 'billingAddress1', 'billingAddress2',
            'billingAddress3', 'billingAddressCity', 'billingAddressState', 'billingAddressZip'
        ];
    }

    const onDetailHandler = (body) => {
        const { details, ...data } = body;
        return data;
    };

    const onEditHandler = (data) => {
        const subAccounts = getValues("subAccounts") ?? [];
        const subAccount = subAccounts.find(account => account.accountId === data.accountId); 
        if (subAccount) {
            setValue(SUB_ACCOUNT_DRAFT, subAccount);
            onCreateEditButtonClicked();
        }
        return;
    };

    const onDeleteHandler = (data) => {
        const subAccounts = getValues("subAccounts") ?? [];
        const index = subAccounts.findIndex(account => account.accountId === data.accountId);
        if (index >= 0) remove(index);
        return;
    };

    return (
        <div className={'container'} style={{ padding: '1rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                    <p style={{ fontSize: '1.2rem', fontWeight: '600' }}>Sub Accounts</p>
                    <p className="sub-title">Create or amend sub accounts</p>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2rem 1rem 1rem 0rem' }}>
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <button type="button" className="btn edit-btn" onClick={onCreateEditButtonClicked}>
                        Create Sub Account
                    </button>
                </div>
                {subAccountRows.length > 0 && (
                    <p style={{ cursor: 'pointer', color: 'var(--green)' }} onClick={() => setShowMoreColumns(!showMoreColumns)}>
                        {showMoreColumns ? 'Less Columns' : 'More Columns'}
                    </p>
                )}
            </div>
            <>
                <SharedTable
                    type={'account'}
                    columns={columns}
                    items={subAccountRows}
                    onDetailHandler={onDetailHandler}
                    onEditHandler={onEditHandler}
                    onDeleteHandler={onDeleteHandler}
                    ref={ref}
                    noResultsMessage={"No sub accounts have been created yet."}
                />

            </>
        </div>
    );
};

export default TopAccountStepFour;
